angular.module( 'acme.view.application.grids.events.templates.reorder', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.grids.events.templates.reorder.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var gridsEventsTemplatesReorder = {
        name: 'application.grids.events.templates.reorder',
        url: '/grids/events/templates/reorder',
        views: {
          "main": {
            controller: 'GridsEventsTemplatesReorderController',
            // Assumes the view is entirely self contained
            templateUrl: 'common/views/grids/events/templates/reorder/reorder.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(gridsEventsTemplatesReorder);
});
